import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlayerJourneysRefreshService {
  private refreshNeededSource = new Subject<void>();

  public refreshNeeded$ = this.refreshNeededSource.asObservable();

  public triggerRefresh(): void {
    this.refreshNeededSource.next();
  }
}
